import * as React from "react"

function SvgTrash(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 17 17" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.45.983h4.1c.755 0 1.367.612 1.367 1.367v.683h2.05c.754 0 1.366.612 1.366 1.367v1.367c0 .754-.612 1.366-1.366 1.366h-.055l-.629 7.517c0 .755-.612 1.367-1.366 1.367H5.083c-.755 0-1.366-.612-1.364-1.31l-.631-7.574h-.055a1.367 1.367 0 01-1.366-1.366V4.4c0-.755.612-1.367 1.366-1.367h2.05V2.35c0-.755.612-1.367 1.367-1.367zM3.033 4.4H13.967v1.367H3.033V4.4zM4.46 7.133h8.082l-.622 7.46-.002.057H5.083L4.46 7.133zM10.55 2.35v.683h-4.1V2.35h4.1z"
        fill="#fff"
      />
    </svg>
  )
}

export default SvgTrash

